import { useMemo } from 'react';

import { useDuration as useStreamDuration } from '@/scenarios/legacy-player/hooks/useDuration';

import { Duration } from '../types/duration';

export const useDuration = () => {
    /** @see OTT-82541 if need hide preroll timeline */
    const prerollDuration = 0;
    const streamDuration = useStreamDuration();

    return useMemo(
        () => new Duration(streamDuration, prerollDuration ?? 0),
        [prerollDuration, streamDuration]
    );
};
